import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { MdOutlineImage } from "react-icons/md";

const logoBoxStyle = {
  width: 32,
  height: 32,
  borderRadius: "6px",
  border: "1px solid var(--neutral-100)",
  background: "var(--white)",
};

// Shows the company logo; an image placeholder when there is no logo
// or the signed logo link has expired and fails to load
const CompanyLogo = ({ logo }: { logo?: string | null }) => {
  const [hasError, setHasError] = useState(false);

  // A new link (e.g. after an upload) gets a fresh chance to load
  useEffect(() => {
    setHasError(false);
  }, [logo]);

  if (!logo || hasError) {
    return (
      <Box
        style={logoBoxStyle}
        display="flex"
        alignItems="center"
        justifyContent="center"
        color="var(--neutral-300)"
      >
        <MdOutlineImage size={18} />
      </Box>
    );
  }

  return (
    <img
      src={logo}
      alt="logo"
      onError={() => setHasError(true)}
      style={{ ...logoBoxStyle, objectFit: "contain" }}
    />
  );
};

export default CompanyLogo;
